// extracted by mini-css-extract-plugin
export var csatScore = "_nf-5";
export var header = "_nf-1";
export var panelWrapper = "_nf-2";
export var postPreview = "_nf-3";
export var rightContent = "_nf-0";
export var wrappingText = "_nf-4";